import CompanySelect, {
  CompanySelectValueType,
} from '../CompanySelect/CompanySelect';
import {
  DataColumn,
  DataTableRow,
  FilterColumn,
  FilterHandler,
} from '../DataTable/DataTable';

type CompanyDataFilterProps<R extends DataTableRow> = {
  secondaryClass?: string;
  valueType?: CompanySelectValueType;
  column: DataColumn<R>;
  handleFilter: FilterHandler;
};

const CompanyDataFilter = <R extends DataTableRow>({
  secondaryClass,
  valueType,
  column,
  handleFilter,
}: CompanyDataFilterProps<R>) => {
  return (
    <CompanySelect
      placeholder=''
      isPlaceHolderSelectable={true}
      multiple={false}
      valid={true}
      secondaryClass={secondaryClass}
      valueType={valueType}
      onChange={(e) => {
        console.log(e.target.value);
        const fc: FilterColumn = {
          columnId: column.id,
          filter: e.target.value === '' ? undefined : e.target.value,
        };
        handleFilter([fc]);
      }}
    />
  );
};

export default CompanyDataFilter;
